// Generated by Melange

import * as Stdlib__Array from "melange/array.js";
import * as JsxRuntime from "react/jsx-runtime";

function s(prim) {
  return prim;
}

function mute(s) {
  if (s === "DF") {
    return "";
  } else {
    return s;
  }
}

function CompPilots$PilotRow(Props) {
  let pilot = Props.pilot;
  return JsxRuntime.jsxs("tr", {
    children: [
      JsxRuntime.jsx("td", {
        children: pilot.pilotId,
        className: "td-pid"
      }),
      JsxRuntime.jsx("td", {
        children: pilot.pilotName
      }),
      Stdlib__Array.mapi((function (i, status) {
        const Key = String(i);
        return JsxRuntime.jsx("td", {
          children: mute(status)
        }, Key);
      }), pilot.pilotStatus)
    ]
  });
}

const PilotRow = {
  mute: mute,
  make: CompPilots$PilotRow
};

function CompPilots(Props) {
  let tasks = Props.tasks;
  let pilots = Props.pilots;
  const xs = Stdlib__Array.map((function (pilot) {
    const Key = pilot.pilotId;
    return JsxRuntime.jsx(CompPilots$PilotRow, {
      pilot: pilot
    }, Key);
  }), pilots);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs("table", {
        children: [
          JsxRuntime.jsx("thead", {
            children: JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("th", {
                  children: "Id",
                  className: "th-pid"
                }),
                JsxRuntime.jsx("th", {
                  children: "Name"
                }),
                Stdlib__Array.mapi((function (i, task) {
                  const Key = String(i);
                  return JsxRuntime.jsx("th", {
                    children: task.taskName
                  }, Key);
                }), tasks)
              ]
            })
          }),
          JsxRuntime.jsx("tbody", {
            children: xs
          })
        ],
        className: "table is-bordered is-striped"
      })]
  });
}

const make = CompPilots;

export {
  s,
  PilotRow,
  make,
}
/* react/jsx-runtime Not a pure module */
